import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import { CoreModule } from './core/core.module';
import { AppInitializerService } from './core/services/app-initializer.service';
import { IntlModule } from '@progress/kendo-angular-intl';
import { HttpInterceptorService } from './core/services/http-interceptor.service';
import { swaggerConf } from './core/api-configuration';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';

import localePl from '@angular/common/locales/pl';
import '@progress/kendo-angular-intl/locales/pl/all';
import { SharedModule } from './common/shared/shared.module';
import { LayoutModule } from './common/layout/layout.module';
import { ViewsModule } from './views/views.module';
import { AuthModule } from './views/auth/auth.module';
import { ApiModule, BASE_PATH } from './api';
import { DashboardModule } from './views/dashboard/dashboard.module';
import { CreateMessageModule } from './views/create-message/create-message.module';

registerLocaleData(localePl);

export function currentUserServiceFactory(initializer: AppInitializerService): Function {
    return () => initializer.init();
}
const MainRouting = [
    AppRoutingModule,
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        CoreModule,
        IntlModule,
        ApiModule.forRoot(swaggerConf),
        SharedModule,
        LayoutModule,
        ViewsModule,
        AuthModule,
        DashboardModule,
        CreateMessageModule,
        // MainRouting Always Should Be LAST!!!
        MainRouting,
    ],
    providers: [
        {provide: BASE_PATH, useValue: null},
        {provide: LOCALE_ID, useValue: 'pl'},
        {
            provide: APP_INITIALIZER,
            useFactory: currentUserServiceFactory,
            deps: [AppInitializerService],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true
        },
    ],
    bootstrap: [AppComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    entryComponents: [
    ]
})
export class AppModule {
}
